import React from "react";
import "./ECLCompoundInput.css";
import { ECLTextInput, ECLThemeImage } from "../../index";
import { translate } from "../../../utilities/Translate";
import useSelectorId from "../../../utilities/hooks/useSelectorId";

export default function ECLCompoundInput(props) {
   const instanceId = useSelectorId();

   return (
      <div
         className={
            props.class ? "compound-input " + props.class : "compound-input"
         }
         id={props.id ? props.id : `compound-container-${instanceId}`}
      >
         {props.icon && props.icon}
         <ECLTextInput
            id={`compound-input-${instanceId}`}
            onChange={(e) => {
               props.onChange(e.target.value);
            }}
            placeholder={props.placeholder}
            value={props.value}
         />
         {props.value != "" && (
            <button
               onClick={(e) => {
                  e.preventDefault();
                  document.querySelector(
                     `#compound-input-${instanceId}`,
                  ).value = "";
                  props.onChange("");
               }}
            >
               <ECLThemeImage
                  fontAwesome="xmark"
                  alt={translate("Clear Field")}
               />
            </button>
         )}
      </div>
   );
}
